import { createSelector } from '@reduxjs/toolkit';
import { selectAccounts } from '../../common/store/selectors';
import { ClientAccount, ClientAccountSelectModel } from '../../common/store/types';
import { selectClientState } from '../../store/selectors';

export const selectCashAccountsState = createSelector(selectClientState, (clientState) => clientState.cashAccounts);
export const selectParameters = createSelector(selectCashAccountsState, (cashAccountsState) => cashAccountsState.parameters);
export const selectCashStatementResults = createSelector(selectCashAccountsState, (cashAccountsState) => cashAccountsState?.cashStatements);
export const selectShowAudValues = createSelector(selectCashAccountsState, (cashAccountsState) => cashAccountsState.showAudValues);
export const selectLastDataRefresh = createSelector(selectCashAccountsState, (cashAccountsState) => cashAccountsState?.lastDataRefresh ?? null);

export const selectPortfolioId = createSelector(selectParameters, (parameters) => parameters.portfolio?.investmentProgramId ?? null);

export const selectAccountsForPortfolio = createSelector(
  selectPortfolioId,
  selectAccounts,
  (portfolioId: number | null, clientAccounts: ClientAccount[]) => {
    const accounts =
      portfolioId !== null ? clientAccounts.filter((clientAccount) => clientAccount.investmentProgramIds.includes(portfolioId)) : clientAccounts;

    const accountsSelectList: ClientAccountSelectModel[] = accounts.map((i) => {
      return {
        accountId: i.accountId,
        accountName: i.accountName,
        accountNumber: i.accountNumber,
        accountIdList: [i.accountId],
      };
    });

    const allAccountIds = accountsSelectList.map((a) => a.accountId as number);
    accountsSelectList
      .sort((a, b) => a.accountName.localeCompare(b.accountName))
      .unshift({ accountId: null, accountNumber: '', accountName: 'All Accounts', accountIdList: allAccountIds });

    return accountsSelectList;
  }
);

export const selectCanShowAudValues = createSelector(selectCashStatementResults, (cashStatements) =>
  (cashStatements?.results ?? []).some((line) => line.balanceAud != null && line.balance != null && line.balanceAud !== line.balance)
);
